const images = {
  dd_logo_rec: require('../images/dd_logo_rec.jpg') ,
  dd_logo: require('../images/dd_logo.png') ,
  spacee_logo: require('../images/SP_LOGO_VC.png') ,
  webinar_logo: require('../images/webinar_logo.png') ,
  avatar: require('../images/Default.png'),
  profilePic: require('../images/Profile Pic.png'),
  teacherIcon: require('../images/workshop_icon_3color.png'),
  sessionBackground: require('../images/intro05.jpg'),
  FVlite_logo: require('../images/FVlite_logo.png'),
  logo: require('../images/logo.png'),
};

export default images;



// WEBPACK FOOTER //
// ./src/config/images.js